module.exports = __webpack_public_path__ + "static/media/23.ff32ed48.png";